module.exports = __webpack_public_path__ + "img/vb.8a046ffd.svg";